import { ConfigService, ErrorsService, User, ModelsList, StoreService, Message } from 'shared';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class UserService extends StoreService<User> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(User);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<User>> {
    return this.http.get<ModelsList<User>>(this.config.apiVerUrl('/app/users'), { params: queryParams });
  }

  protected insert(values: User): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/users'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/users/${id}`));
  }

  public sendNewPassword(id): Observable<Message> {
    return this.http.get<Message>(this.config.apiVerUrl(`/app/users/${id}/send-new-password`));
  }

  protected update(id, values: User): Observable<User> {
    return this.http.put<User>(this.config.apiVerUrl(`/app/users/${id}`), values);
  }

  public checkEmail(email: string, id?: number): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl('/app/users/check-email'), { email, id });
  }

  public startSession(id: number): Observable<number> {
    return this.http.put<number>(this.config.apiVerUrl('/app/users/start-session'), {
      user: id
    });
  }

  public updateSession(id: number): Observable<boolean> {
    return this.http.put<boolean>(this.config.apiVerUrl('/app/users/update-session'), {
      'session-id': id
    });
  }

}
